import React from 'react';
import FileSaver from 'file-saver';
import { SharedUI } from './SharedUI';
import { DialogWrapper } from '../../GenericUI/DialogWrapper';
import { generateMetalink } from '../../../utils/createMetaLink';
export const DownloadUI = ({ completed, fileListObject, myQueryLimit, }) => {
    const COMPLETE = 100; // Percentage
    return (React.createElement(DialogWrapper, { title: 'Generate link collection', buttonTitle: 'Download Metalink', buttonDisabled: completed !== COMPLETE, buttonCallback: () => {
            const blob = new Blob([generateMetalink(fileListObject)], {
                type: 'text/plain;charset=utf-8',
            });
            FileSaver.saveAs(blob, 'datasets.metalink');
        }, size: false, clearOnClose: false },
        React.createElement(SharedUI, Object.assign({}, {
            completed,
            fileListObject,
            myQueryLimit,
        }))));
};
